module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#personalise",
      toString: function () {
        return this.url;
      }
    }